import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  search(items: any[], term: string): any[] {
    return items?.filter(a => {
      return term ? a.name?.toUpperCase().indexOf(term.toUpperCase()) !== -1 : true;
    });
  }

}
